// React
import React, { useState } from "react";
import PropTypes from "prop-types";

// Components
import Table from "../table/Table";
import BenchmarkView from "./BenchmarkView";
import Modal from "../modal/Modal";

// Functions
import { tranStr } from "../../utils/translation";
import {
  getDecoratedData,
  getRoleBasedColumns,
} from "./BenchmarkControlTable.functions";
// Style
import "./BenchmarkControlTable.css";
import { columns } from "../benchmarking-project/BenchmarkingTable.functions";

BenchmarkControlTable.propTypes = {
  selectedBenchmarks: PropTypes.array,
  setSelected: PropTypes.func,
  data: PropTypes.array,
  user: PropTypes.object,
  sensitivityLevelCodes: PropTypes.object,
  setSelectedMenuColumns: PropTypes.func,
};

export default function BenchmarkControlTable(props) {
  const { selectedBenchmarks, setSelected, user, sensitivityLevelCodes } =
    props;
  const { data } = props;
  const { setSelectedMenuColumns } = props;

  const [selectedRow, setSelectedRow] = useState({});
  const [modal, setModal] = useState(false);

  return (
    <div>
      <Table
        title={tranStr("Benchmarking Control Table")}
        tableArray={getDecoratedData(data, sensitivityLevelCodes)}
        columns={getRoleBasedColumns(user, columns())}
        tableSize={20}
        isTitleDisabled={true}
        isTotalDisabled={true}
        // Checked Selection
        checked={selectedBenchmarks}
        setChecked={setSelected}
        // Row Selection
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        // Modal Control
        tableName={"Benchmarking Control Table"}
        setModal={setModal}
        moduleId={user.id}
        isMenuAvailable={true}
        isCheckAllAvailable={true}
        setSelectedMenuColumns={setSelectedMenuColumns}
      />
      <Modal
        // Modal Props
        title={"Selected Item"}
        Component={BenchmarkView}
        modal={modal}
        setModal={setModal}
        // Component Props
        selectedRow={selectedRow}
        masterData={getDecoratedData(data, sensitivityLevelCodes)}
        user={user}
      />
    </div>
  );
}
